export default __webpack_public_path__ + "static/media/640_dummy2016-streetfashion01-mobile-de.2e005d79.png";